import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { FocusAreaIcon } from '@atlassian/focus-area-icon';

import { FocusAreaIconMap } from './main';
import type { FocusAreaIconsProps } from './types';

export const STATUS_TO_COLOR_MAP = {
	pending: token('color.icon.accent.gray'),
	paused: token('color.icon.accent.gray'),
	on_track: token('color.icon.accent.lime'),
	at_risk: token('color.icon.warning'),
	off_track: token('color.icon.accent.red'),
	completed: token('color.icon.accent.gray'),
} as const;

const iconContainer = xcss({
	flexShrink: 0,
	lineHeight: 1,
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
});

export default function FocusAreaIcons({
	size,
	level,
	status,
	customColor,
	testId,
	label,
}: FocusAreaIconsProps) {
	// Focus area icons have been migrated to the new @atlassian/focus-area-icon
	if (fg('mercury_enable_new_focus_area_icons')) {
		return (
			<FocusAreaIcon
				status={status}
				// Since the customColor prop here does not enforce the new IconColor type and to avoid backwards
				// compatility issues, please use @atlassian/focus-area-icon if customColor prop is needed
				// https://hello.atlassian.net/wiki/spaces/DST/pages/3748692796/New+ADS+iconography+Code+migration+guide
				spacing={size === 'medium' || size === 'large' ? 'spacious' : 'compact'}
				testId={testId}
				label={label}
			/>
		);
	}

	const adjustedSize = size === 'xsmall' ? 'xxsmall' : size;
	return (
		<Box xcss={iconContainer} as="span">
			{FocusAreaIconMap[level](
				customColor ?? (status ? STATUS_TO_COLOR_MAP[status] : 'currentColor'),
				adjustedSize ?? 'medium',
				testId,
				label,
			)}
		</Box>
	);
}
